export const PREFERRED_START_OPTIONS = [
  {
    valueForActive: "am/pm",
    value: "am/pm",
    text: "AM/PM",
  },
  {
    valueForActive: "pm/am",
    value: "pm/am",
    text: "PM/AM",
  },
  {
    valueForActive: "any/undecided",
    value: "any/undecided",
    text: "Any/Undecided",
  },
];

export const PREFERRED_START_EXTRA_TIME_OPTION = {
  valueForActive: "am/am",
  value: "am/am",
  text: "AM/AM",
};
